<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" [textHeader]="textHeader" modalContentId="modal-motorista"
  [customClass]="'modal-lg'">
  <app-motorista-cadastro-form #motoristaForm [modal]="true" (salvar)="onSalvar($event)" (cancelar)="onCancelar()"></app-motorista-cadastro-form>
</app-temp-modal-cadastro>